import { render, staticRenderFns } from "./CriticalitiesImportFile.vue?vue&type=template&id=4f14d81c&"
import script from "./CriticalitiesImportFile.vue?vue&type=script&lang=js&"
export * from "./CriticalitiesImportFile.vue?vue&type=script&lang=js&"
import style0 from "./CriticalitiesImportFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports